import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Typography,
  Box,
  Paper,
  Breadcrumbs,
  Link,
} from '@mui/material';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Breadcrumbs sx={{ mb: 4 }} aria-label="breadcrumb">
        <Link color="inherit" href="/">
          {t('common.home', 'Inicio')}
        </Link>
        <Typography color="text.primary">{t('legal.terms', 'Términos y Condiciones')}</Typography>
      </Breadcrumbs>

      <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('legal.terms', 'Términos y Condiciones')}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {t('legal.lastUpdated', 'Última actualización')}: 17/05/2023
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            1. {t('legal.termsIntroduction', 'Introducción')}
          </Typography>
          <Typography paragraph>
            {t('legal.termsIntroductionText', 'Estos términos y condiciones regulan el uso del servicio ofrecido por TuttoGym en su sitio web, aplicación móvil y plataformas relacionadas. Al registrarte y utilizar nuestros servicios, aceptas estar sujeto a estos términos y condiciones, así como a nuestra Política de Privacidad.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. {t('legal.servicesDescription', 'Descripción del servicio')}
          </Typography>
          <Typography paragraph>
            {t('legal.servicesDescriptionText', 'TuttoGym ofrece una plataforma que permite a los usuarios acceder a múltiples gimnasios y actividades deportivas mediante una suscripción. Nuestro servicio incluye la gestión de reservas, acceso a diferentes instalaciones deportivas y actividades según el plan contratado.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            3. {t('legal.accountRegistration', 'Registro de cuenta y responsabilidades')}
          </Typography>
          <Typography paragraph>
            {t('legal.accountRegistrationText', 'Para utilizar nuestros servicios, debes registrarte y crear una cuenta. Al hacerlo, aceptas proporcionar información verdadera, precisa y completa. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, así como de todas las actividades que ocurran bajo tu cuenta.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. {t('legal.subscriptionTerms', 'Términos de suscripción y pagos')}
          </Typography>
          <Typography paragraph>
            {t('legal.subscriptionTermsText', 'TuttoGym ofrece diferentes planes de suscripción. Al contratar un plan, aceptas pagar las tarifas correspondientes. Los pagos son recurrentes y se realizarán de forma automática según el ciclo de facturación seleccionado. Puedes cancelar tu suscripción en cualquier momento, la cual será efectiva al final del período de facturación actual.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. {t('legal.useRestrictions', 'Restricciones de uso')}
          </Typography>
          <Typography paragraph>
            {t('legal.useRestrictionsText', 'El acceso a las instalaciones y actividades está sujeto a disponibilidad y a los términos específicos de cada gimnasio o centro. TuttoGym se reserva el derecho de restringir el acceso en caso de uso indebido o incumplimiento de las normas establecidas.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. {t('legal.intellectualProperty', 'Propiedad intelectual')}
          </Typography>
          <Typography paragraph>
            {t('legal.intellectualPropertyText', 'Todo el contenido presente en nuestro sitio web y aplicación, incluyendo textos, gráficos, logotipos, iconos, imágenes y software, es propiedad de TuttoGym o sus proveedores y está protegido por leyes de propiedad intelectual.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. {t('legal.liability', 'Limitación de responsabilidad')}
          </Typography>
          <Typography paragraph>
            {t('legal.liabilityText', 'TuttoGym no se hace responsable por lesiones o daños que puedan ocurrir durante la práctica de actividades deportivas. Los usuarios participan bajo su propio riesgo y deben seguir las instrucciones y normas de seguridad de cada instalación.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            8. {t('legal.termsModification', 'Modificación de términos')}
          </Typography>
          <Typography paragraph>
            {t('legal.termsModificationText', 'TuttoGym se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación. El uso continuado de nuestros servicios después de cualquier cambio constituye tu aceptación de los nuevos términos.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            9. {t('legal.terminationOfService', 'Terminación del servicio')}
          </Typography>
          <Typography paragraph>
            {t('legal.terminationOfServiceText', 'TuttoGym se reserva el derecho de suspender o terminar tu cuenta y acceso a los servicios en caso de incumplimiento de estos términos y condiciones, uso fraudulento o cualquier actividad que pueda perjudicar a la plataforma o a otros usuarios.')}
          </Typography>

          <Typography variant="h6" gutterBottom>
            10. {t('legal.applicableLaw', 'Ley aplicable')}
          </Typography>
          <Typography paragraph>
            {t('legal.applicableLawText', 'Estos términos y condiciones se rigen por las leyes de España. Cualquier disputa relacionada con estos términos se resolverá en los tribunales competentes de Barcelona.')}
          </Typography>
        </Box>

        <Box sx={{ mt: 6 }}>
          <Typography variant="body2" color="text.secondary">
            {t('legal.contactForQuestions', 'Si tienes alguna pregunta sobre estos Términos y Condiciones, por favor contáctanos en')}: <Link href="mailto:legal@tuttogym.com">legal@tuttogym.com</Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Terms; 